<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-default">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-success">
                        <span class="mdi mdi-help"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>¿Está seguro de iniciar la orden?</p>
                    </div>
                </div>
                <div class="menu-btn-modal-container">
                    <button class="menu-modal-btn menu-modal-confirm-btn" @click="progressOrderReference">Sí, iniciar</button>
                    <button class="menu-modal-btn menu-modal-cancel-btn" @click="closeModal">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../../../common/utils';
import axios from 'axios';
export default {
    name: "StartOrderReferenceButtonActionModal",
    props: {
        closeModal: {
            type: Function,
            required: true,
        },
        orderReferenceId: {
            type: Number,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
    },
    methods: {
        progressOrderReference() {
            this.endOfAction();
            this.closeModal();
            let formData = {
                producedQuantity: 0,
                orderReferenceId: this.orderReferenceId,
            };
            axios.post('/api/production-line/progress-order', formData)
                .then(response => {
                    showCustomSuccessSweetAlert('La orden ha sido iniciada correctamente');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
    },
};
</script>